import { Input, FormInstance, Form } from "antd";
import MaskedInput from "react-text-mask";
import { WRONG_PHONE_FORMAT, PHONE_REQUIRED } from "../../lib/constants";
import { PHONE_MASK_RULE, PHONE_RULE } from "../../lib/validationRules";
import { useValidateOnBlur } from "../../lib/hooks/validateOnBlur";
import { NamePath } from "antd/es/form/interface";
import { useMemo } from "react";

type PhoneInputProps = {
  form: FormInstance;
  label?: string;
  size?: "large" | "middle";
  formItemMargin?: string;
  initialValue?: string;
  disabled?: boolean;
  name?: NamePath;
  hideAddon?: boolean;
  notRequired?: boolean;
  errorPatternMessage?: string;
  placeholder?: string;
  inputClassName?: string;
};

export const PhoneInput = ({
  form,
  label,
  size,
  formItemMargin,
  initialValue,
  disabled,
  name,
  hideAddon,
  notRequired,
  errorPatternMessage,
  placeholder,
  inputClassName,
}: PhoneInputProps) => {
  const [validateOnBlur] = useValidateOnBlur(form);

  const rules = useMemo(() => {
    const value: any[] = [
      {
        pattern: PHONE_RULE,
        message: errorPatternMessage || WRONG_PHONE_FORMAT,
        validateTrigger: "onSubmit",
      },
    ];

    !notRequired &&
      value.push({
        required: true,
        message: PHONE_REQUIRED,
        validateTrigger: "onSubmit",
      });

    return value;
  }, [notRequired, errorPatternMessage]);

  return (
    <Form.Item
      name={name || "phone"}
      label={label === "" ? "" : label || "Phone"}
      className={formItemMargin || "mb-5"}
      initialValue={initialValue || ""}
      rules={rules}
    >
      <MaskedInput
        mask={PHONE_MASK_RULE}
        guide={false}
        showMask
        render={(ref, props) => {
          const value = form.getFieldValue(name || "phone");

          const newProps = {
            ...props,
            onBlur: (e: any) => validateOnBlur(e, "phone"),
          };

          return (
            <Input
              disabled={disabled || false}
              addonBefore={hideAddon ? "" : "+1"}
              value={value}
              size={size || "large"}
              ref={(input: any) => ref(input && input.input)}
              placeholder={placeholder || ""}
              className={inputClassName || ""}
              {...newProps}
            />
          );
        }}
      />
    </Form.Item>
  );
};
